import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { CollectionSequenceInitialState } from '../globalSlices/collectionSequenceSlice';
import {
  getSupplierCollectionSequences,
  createCollectionSequence,
  updateCollectionSequence,
  deleteCollectionSequence,
} from '../services/collectionSequenceService';
import { CollectionSequenceWithUser } from '@dill/dill-shared';

export const getSupplierCollectionSequencesExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionSequenceInitialState>
) => {
  const reducerId = 'getSupplierCollectionSequences';
  builder.addCase(getSupplierCollectionSequences.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierCollectionSequences.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.sequences = action.payload.data as CollectionSequenceWithUser[];
      }
    }
  );
  builder.addCase(getSupplierCollectionSequences.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const createCollectionSequenceExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionSequenceInitialState>
) => {
  const reducerId = 'createCollectionSequence';
  builder.addCase(createCollectionSequence.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createCollectionSequence.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.sequences = [action.payload.data as CollectionSequenceWithUser, ...state.sequences];
      }
    }
  );
  builder.addCase(createCollectionSequence.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updateCollectionSequenceExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionSequenceInitialState>
) => {
  const reducerId = 'updateCollectionSequence';
  builder.addCase(updateCollectionSequence.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(updateCollectionSequence.fulfilled, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(updateCollectionSequence.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteCollectionSequenceExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionSequenceInitialState>
) => {
  const reducerId = 'deleteCollectionSequence';
  builder.addCase(deleteCollectionSequence.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(deleteCollectionSequence.fulfilled, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(deleteCollectionSequence.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
